<template>
  <div class="bg-white text-center">
    <div class="p-8 pt-12 pb-16 border border-b-0 border-gray-300">
      <FontAwesomeIcon
        :icon="faCameraRetro"
        class="text-secondary text-6xl mb-8"
      />

      <h3 class="mb-2">
        We're working on it!
      </h3>

      <p>
        Your photos aren't online just yet. Sign up to get notified as soon as they're available.
      </p>
    </div>

    <AppButton
      class="btn btn-solid btn-secondary rounded-none w-full p-4"
      @click="showNotifyMeModal = true"
    >
      Notify Me
    </AppButton>
  </div>

  <Transition name="fade">
    <AppModal
      v-if="showNotifyMeModal"
      class="notify-me-modal"
      size="lg"
      :disabled="isSubmitting"
      @close="showNotifyMeModal = false"
    >
      <NotifyMeForm
        v-model:is-submitting="isSubmitting"
        :event="event"
        @close="showNotifyMeModal = false"
      />
    </AppModal>
  </Transition>
</template>

<script setup>
import { ref } from 'vue';

import {
  AppButton,
  AppModal,
} from '@/components/app';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCameraRetro } from '@fortawesome/pro-light-svg-icons';

import { NotifyMeForm } from '@/components/forms';

defineProps({
  event: {
    type: Object,
    required: true,
  },
});

const showNotifyMeModal = ref(false);
const isSubmitting = ref(false);
</script>
